
//  Authorization UI Helper - For frontend display only

class AuthorizationService {

// UI helper for basic checks based on user data

  static uiHelper(userSession) {
    if (!userSession) return {
      isGod: false,
      hasElevatedAccess: false,
      hasEarlyAccess: false,
      hasPremiumPlan: false,
      canShowGodPanel: false,
      canShowImmortalFeatures: false
    };

    const authGrade = userSession.authorizationGrade;
    const planType = userSession.planType;
    const earlyAdopter = userSession.earlyAdopter;
    const hasPaid = userSession.hasPaid;

    return {
      isGod: authGrade === 'God',
      hasElevatedAccess: ['God', 'Immortal'].includes(authGrade),
      hasEarlyAccess: Boolean(earlyAdopter),
      hasPremiumPlan: ['Elite', 'Pro'].includes(planType),
      canShowGodPanel: authGrade === 'God',
      canShowImmortalFeatures: ['God', 'Immortal'].includes(authGrade),
      canShowPaidFeatures: hasPaid && ['God', 'Immortal', 'Mortal'].includes(authGrade)
    };
  }

  /**
   * Check authorization grade level
   */
  static hasMinimumGrade(userSession, requiredGrade) {
    const levels = {
      'God': 100,
      'Immortal': 80,
      'Mortal': 60,
      'Restricted': 40,
      'Suspended': 20,
      'Banned': 10,
      'Unassigned': 0
    };

    const userLevel = levels[userSession?.authorizationGrade] || 0;
    const requiredLevel = levels[requiredGrade] || 0;
    
    return userLevel >= requiredLevel;
  }
}

export default AuthorizationService;
